import {useMutation, UseMutationOptions} from '@tanstack/react-query';
import {TriumphPayAuditRegistrationRequest} from '@shipwell/backend-core-sdk';

import {updateTriumphpayauditRegistration} from 'App/api/integrations/typed';

const useUpdateTriumphpayauditRegistration = (
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTriumphpayauditRegistration>>,
    unknown,
    TriumphPayAuditRegistrationRequest
  >
) => {
  return useMutation<
    Awaited<ReturnType<typeof updateTriumphpayauditRegistration>>,
    unknown,
    TriumphPayAuditRegistrationRequest
  >(async (body) => await updateTriumphpayauditRegistration(body), {
    ...mutationOptions
  });
};

export default useUpdateTriumphpayauditRegistration;
